export default __webpack_public_path__ + "static/media/banner-collapse.21126047.svg";